const moment = require('moment')
// eslint-disable-next-line
const momentTimezone = require('moment-timezone')

export default class DateUtil {
  static formatToTzSimple(date, timezone) {
    return moment(date).tz(timezone).format('MMM Do, YYYY')
  }
  // HACK: needs to be fixed, before next year
  static isDefaultEndDate(date) {
    return parseInt(moment(date).format('YYYY')) > '2025'
  }
}